// src/utils/widgetPatterns.ts

export const WIDGET_PATTERNS = {
  POPULAR_ITEMS: ["popularitems", "popular"],
  LIMITED_TIME_ITEMS: ["limitedtime", "limited"],
} as const;

export function matchesPattern(
  widgetType: string = "",
  patterns: readonly string[],
): boolean {
  return patterns.some((pattern) =>
    widgetType.toLowerCase().includes(pattern.toLowerCase()),
  );
}

export function isPopularItemsWidget(widgetType: string = "") {
  return matchesPattern(widgetType, WIDGET_PATTERNS.POPULAR_ITEMS);
}

export function isLimitedTimeWidget(widgetType: string = "") {
  return matchesPattern(widgetType, WIDGET_PATTERNS.LIMITED_TIME_ITEMS);
}
